// packages/web-ui/src/state/sessions-store-singleton.ts
//
// Module-level singleton for the sessions vanilla store. Shared between
// `ContextPanel.tsx` (SessionList sidebar) and `TabContent.tsx`
// (auto-selector for /chat with no sessionId) so both surfaces see the
// same list state without re-fetching.

import { createSessionsStore } from './sessions.js';

export const sessionsStoreSingleton = createSessionsStore();
